























































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbSelect } from '@folky-tools/mdbvue';
import { required } from 'vuelidate/lib/validators';
import { globalizationService } from '@/services';
import { BusinessAddress } from '@/models/businesses/business-address';
import { Country } from '@/models/globalization/country';
import { State } from '@/models/globalization/state';

@Component({
    components: { mdbInput, mdbSelect, mdbRow, mdbCol },
    validations: {
        address: {
            street: { required },
            number: { required },
            postalCode: { required },
            city: { required },
            stateName: { required },
            countryName: { required }
        }
    }
})
export default class EditPickupAddress extends Vue {
    @Prop(BusinessAddress) private address!: BusinessAddress;
    private countries: Country[] = [];
    private states: State[] = [];

    private async mounted(): Promise<void> {
        const countries = await globalizationService.getCountries();

        if (this.address.countryId! > 0) {
            countries.find(c => c.id === this.address.countryId)!.selected = true;
        } else if (countries.length === 1) {
            countries[0].selected = true;
        }
        this.countries = countries;
    }

    private async onChangeCountry(value: number, text: string): Promise<void> {
        if (value) {
            const country = this.countries.find(c => c.id! === value);

            this.address.countryId = country!.id;
            this.address.countryName = country!.name;

            const states = await globalizationService.getStates(value);

            if (this.address.stateId! > 0 && states.some(s => s.id === this.address.stateId!)) {
                states.find(s => s.id === this.address.stateId)!.selected = true;
            }
            this.states = states;
        } else {
            this.address.countryId = undefined;
            this.address.countryName = undefined;
            this.address.stateId = undefined;
            this.address.stateName = undefined;

            this.states = [];
        }
    }

    private onChangeState(value: number, text: string): void {
        if (value) {
            const state = this.states.find(s => s.id! === value);

            this.address.stateId = state!.id;
            this.address.stateName = state!.name;
        } else {
            this.address.stateId = undefined;
            this.address.stateName = undefined;
        }
    }

    private hasErrors(): boolean {
        this.$v.address.$touch();
        if (this.$v.address.$error) {
            return true;
        }
        return false;
    }
}
